import { Service, ServiceRoute } from '../../../../types';
import {
  SvgDeliverablesManagement,
  SvgDesignReview,
  SvgDesignReview2D,
  SvgDesignTask,
  SvgDesignValidation,
  SvgHomeIcon,
  SvgIssueResolution,
  SvgProjectInsights,
  SvgTwoDocuments,
  SvgWorkExchange,
} from './ServiceIcons';
import { ServiceRoutesBuilder } from './ServiceRotuesBuilder';
import * as Constants from '../../../../utils/constants';

const serviceRoutes = {
  [Constants.ServiceRegistry.projectWise365Id]: new ServiceRoutesBuilder([])
    .addRoute('Project Home', 'home', SvgHomeIcon)
    .addRoute('Work Inbox', 'tasks', SvgWorkExchange)
    .addRoute('Design Tasks', 'design-tasks', SvgDesignTask)
    .addRoute('Documents', 'documents', SvgTwoDocuments)
    .addRoute('Document Review', 'document-reviews', SvgDesignReview2D)
    .addRoute('Design Review', 'design-reviews', SvgDesignReview)
    .addRoute('Design Validation', 'design-validation', SvgDesignValidation)
    .addRoute('Issues', 'issues', SvgIssueResolution)
    .addRoute('Deliverables', 'deliverables', SvgDeliverablesManagement)
    .addRoute('Insights', 'insights', SvgProjectInsights)
    .build(),
};

export function getServiceRoutes(service?: Service): ServiceRoute[] {
  return service ? serviceRoutes[service.id] : [];
}

export function getServiceRouteName(
  service?: Service,
  serviceRouteValue?: string
): string | undefined {
  const routes = getServiceRoutes(service);
  return serviceRouteValue
    ? routes.find(route => route.value === serviceRouteValue)?.text
    : routes[0]?.text;
}
